import React from 'react';
import Icon from '../../../components/AppIcon';

const SyncSummaryCard = ({ syncResult }) => {
  const getStatusIcon = () => {
    if (syncResult.status === 'completed') {
      return syncResult.failedCount > 0 ? 'AlertTriangle' : 'CheckCircle';
    }
    return 'XCircle';
  };

  const getStatusColor = () => {
    if (syncResult.status === 'completed') {
      return syncResult.failedCount > 0 ? 'text-warning' : 'text-success';
    }
    return 'text-error';
  };

  const getStatusBgColor = () => {
    if (syncResult.status === 'completed') {
      return syncResult.failedCount > 0 ? 'bg-warning/10' : 'bg-success/10';
    }
    return 'bg-error/10';
  };

  const formatDuration = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}m ${remainingSeconds}s`;
  };

  return (
    <div className={`p-6 rounded-lg border border-border ${getStatusBgColor()}`}>
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className={`p-2 rounded-lg ${getStatusBgColor()}`}>
            <Icon name={getStatusIcon()} size={24} className={getStatusColor()} />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-text-primary">
              {syncResult.status === 'completed' ? 'Sync Completed' : 'Sync Failed'}
            </h2>
            <p className="text-sm text-text-secondary">
              {syncResult.playlistName} → {syncResult.destinationPlatform}
            </p>
          </div>
        </div>
        <div className="text-right">
          <p className="text-xs text-text-muted">Duration</p>
          <p className="text-sm font-medium text-text-primary">
            {formatDuration(syncResult.duration)}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="text-center p-3 bg-surface rounded-lg">
          <p className="text-2xl font-bold text-text-primary">{syncResult.totalTracks}</p>
          <p className="text-xs text-text-secondary">Total Tracks</p>
        </div>
        <div className="text-center p-3 bg-success/10 rounded-lg">
          <p className="text-2xl font-bold text-success">{syncResult.successCount}</p>
          <p className="text-xs text-text-secondary">Successful</p>
        </div>
        <div className="text-center p-3 bg-error/10 rounded-lg">
          <p className="text-2xl font-bold text-error">{syncResult.failedCount}</p>
          <p className="text-xs text-text-secondary">Failed</p>
        </div>
        <div className="text-center p-3 bg-warning/10 rounded-lg">
          <p className="text-2xl font-bold text-warning">{syncResult.duplicatesCount}</p>
          <p className="text-xs text-text-secondary">Duplicates</p>
        </div>
      </div>

      <div className="mt-4 w-full bg-surface-secondary rounded-full h-2">
        <div 
          className="bg-success h-2 rounded-full transition-all duration-300"
          style={{ width: `${(syncResult.successCount / syncResult.totalTracks) * 100}%` }}
        ></div>
      </div>
      <p className="text-xs text-text-muted mt-2 text-center">
        {Math.round((syncResult.successCount / syncResult.totalTracks) * 100)}% Success Rate
      </p>
    </div>
  );
};

export default SyncSummaryCard;